import apiClient from './client'
export const sparks = {
    getSparks: (query: any) =>
        apiClient.get('events', { params: { ...query } }),
}
